import { createContext } from "react";
import { Client } from 'openapi-fetch'
import { paths as apiClientPaths } from "../../types/api";
import { paths as authClientPaths } from "../../types/auth";

export interface FetchClients {
  apiClient: Client<apiClientPaths>;
  authClient?: Client<authClientPaths>;
}

export const FetchClientsContext = createContext<FetchClients>(null!)
